












import Vue from "vue";
import { createComponent } from "@vue/composition-api";
import { formValidator } from "@/shared/formValidator";
import { required } from "@/shared/validationRules";
import { ZastosowanieCategory } from "@megarax/client/src/resources/plm";
import AttributeTable from "./AttributeTable.vue";

const validationRules = {
  name: required,
};

export default createComponent({
  components: {
    AttributeTable,
  },
  props: {
    value: {
      type: ZastosowanieCategory,
      required: true,
    },
  },
  setup(props, ctx) {
    return {
      ...formValidator(),
      validationRules,
    };
  },
});
